// GTM dataLayer event pushes — loaded deferred on all pages.
// Buttons must carry data-product-id, data-product-title, data-product-price,
// data-product-currency, data-product-handle, data-product-description attributes.

document.addEventListener("DOMContentLoaded", function () {

  // Add to Cart — product card / recommended buttons
  document.querySelectorAll(".add-to-cart-button").forEach(function (button) {
    button.addEventListener("click", function () {
      var productId = button.getAttribute("data-product-id");
      var productTitle = button.getAttribute("data-product-title");
      var productPrice = button.getAttribute("data-product-price");
      var productCurrency = button.getAttribute("data-product-currency");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "add_to_cart",
        ga: {
          currency: productCurrency,
          value: productPrice,
          items: [
            {
              item_id: productId,
              item_name: productTitle,
              price: productPrice,
              quantity: 1,
              item_list_name: "Related Products",
            },
          ],
        },
        fb: {
          content_ids: [productId],
          content_name: productTitle,
          content_type: "product",
          content_category: "recommended",
          contents: [
            {
              id: productId,
              quantity: 1,
              price: productPrice,
              title: productTitle,
              handle: button.getAttribute("data-product-handle"),
              description: button.getAttribute("data-product-description"),
            },
          ],
          currency: productCurrency,
          value: productPrice,
          num_items: 1,
        },
      });
    });
  });

  // Remove from Cart
  document.querySelectorAll(".remove-from-cart-button").forEach(function (button) {
    button.addEventListener("click", function () {
      var productId = button.getAttribute("data-product-id");
      var productTitle = button.getAttribute("data-product-title");
      var productPrice = button.getAttribute("data-product-price");
      var productCurrency = button.getAttribute("data-product-currency");
      var productQty = button.getAttribute("data-product-Qty");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "remove_from_cart",
        ga: {
          currency: productCurrency,
          value: productPrice,
          items: [
            {
              item_id: productId,
              item_name: productTitle,
              price: productPrice,
              quantity: productQty,
            },
          ],
        },
        fb: {
          content_ids: [productId],
          content_name: productTitle,
          content_type: "product",
          content_category: "recommended",
          contents: [
            {
              id: productId,
              quantity: productQty,
              price: productPrice,
              title: productTitle,
              handle: button.getAttribute("data-product-handle"),
              description: button.getAttribute("data-product-description"),
            },
          ],
          currency: productCurrency,
          value: productPrice,
          num_items: 1,
        },
      });
    });
  });

  // Page View
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "page_view",
    ga: {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
    },
    fb: {
      page_title: document.title,
      page_location: window.location.href,
      page_path: window.location.pathname,
    },
  });

  // View Item — product pages only
  // NOTE: selectors below target class names from the source theme. Verify these
  // match the actual markup in the current product template before relying on view_item data.
  if (document.body.classList.contains("product")) {
    var variantInput = document.querySelector(".product-form .product-variant-id");
    var titleEl = document.querySelector(".product-title");
    var priceEl = document.querySelector(".product-price");

    if (variantInput && titleEl && priceEl) {
      var productId = variantInput.value;
      var productTitle = titleEl.innerText;
      var productPrice = priceEl.innerText;
      var productCurrency = "";
      var productHandle = "";
      var productDescription = "";

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_item",
        ga: {
          currency: productCurrency,
          value: productPrice,
          items: [
            {
              item_id: productId,
              item_name: productTitle,
              price: productPrice,
            },
          ],
        },
        fb: {
          content_ids: [productId],
          content_name: productTitle,
          content_type: "product",
          content_category: "recommended",
          contents: [
            {
              id: productId,
              price: productPrice,
              title: productTitle,
              handle: productHandle,
              description: productDescription,
            },
          ],
          currency: productCurrency,
          value: productPrice,
          num_items: 1,
        },
      });
    }
  }

  // Nav Item Clicked
  document.querySelectorAll(".template-nav-item").forEach(function (navItem) {
    navItem.addEventListener("click", function () {
      var navItemId = navItem.getAttribute("data-nav-id");
      var navItemName = navItem.getAttribute("data-nav-name");

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "nav_item_clicked",
        ga: {
          nav_item_id: navItemId,
          nav_item_name: navItemName,
        },
        fb: {
          content_ids: [navItemId],
          content_name: navItemName,
        },
      });
    });
  });

  // Go to Cart Click
  document.querySelector(".go-to-cart-button")?.addEventListener("click", function () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "go_to_cart_click",
      ga: {},
      fb: {},
    });
  });

  // Initiate Checkout / Begin Checkout — fires when the real checkout button
  // is clicked (id="checkout2" / .cart__checkout-button in cart-footer.liquid
  // and cart.liquid). Pushes both "initiate_checkout" (Meta Pixel naming)
  // and "begin_checkout" (GA4's reserved ecommerce event name) since they
  // are not interchangeable and downstream tags key off the exact name.
  // Delegated on document (not the button itself) so it still fires after the
  // cart drawer re-renders its innerHTML on every cart update.
  // Cart contents are read from Shopify's own /cart.js endpoint rather than
  // scraped from the DOM, since this theme's line-item markup carries no
  // data-product-* attributes.
  document.addEventListener("click", function (event) {
    var checkoutBtn = event.target.closest("#checkout2, .cart__checkout-button");
    if (!checkoutBtn) return;

    fetch((window.Shopify?.routes?.root || "/") + "cart.js")
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (item) {
          return {
            item_id: item.variant_id,
            item_name: item.product_title,
            price: item.price / 100,
            quantity: item.quantity,
          };
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "initiate_checkout",
          ga: {
            currency: cart.currency,
            value: cart.total_price / 100,
            items: items,
          },
          fb: {
            content_ids: items.map(function (item) { return item.item_id; }),
            content_name: "Checkout",
            content_type: "product",
            contents: items,
            currency: cart.currency,
            value: cart.total_price / 100,
            num_items: cart.item_count,
          },
        });

        // GA4's reserved ecommerce event is named "begin_checkout", not
        // "initiate_checkout" (that's the Meta Pixel standard name pushed
        // above). Pushed separately, matching every other GA4 event in this
        // file, so GTM's begin_checkout trigger has something to catch.
        window.dataLayer.push({
          event: "begin_checkout",
          ga: {
            currency: cart.currency,
            value: cart.total_price / 100,
            items: items,
          },
        });
      })
      .catch(function (err) {
        console.error("initiate_checkout tracking error:", err);
      });
  });
});



document.addEventListener("click", function (event) {
  const proceedBtn = event.target.closest(".procced__btn");
  if (!proceedBtn) return;
  
  const quizEl = proceedBtn.closest("collection-quiz");
  const quizType = quizEl ? quizEl.dataset.quizType : null;
  //alert("proceed button clicked, quiz_type: " + quizType);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "quiz_proceed_btn",
    quiz_type: quizType,
  });
});

document.addEventListener("click", function (event) {
  const nextBtn = event.target.closest(".quiz-next-btn");
  if (!nextBtn) return;

  const currentStep = nextBtn.getAttribute("current_step");
  const currentSelectValue = nextBtn.getAttribute("current_select_value");
  //alert("next button clicked, current_step: " + currentStep + ", current_select_value: " + currentSelectValue);

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "quiz_selected_options",
    current_step: currentStep,
    current_select_value: currentSelectValue,
  });
});

// TEMPORARY TEST — confirm cart icon click is detected. Remove after verifying.
document.addEventListener("click", function (event) {
  const cartIcon = event.target.closest(".dev_desktop_cart_icon");
  if (!cartIcon) return;
  //alert("cart icon clicked");
});
